/* ===========================================================================
   VJ-CORR-D369 — LES ONGLETS DE LA FICHE ET LES NOTES « AVANT D'ACHETER »
   14 septembre 2026, soir (dix-huitième tour) — balisage : snippets/vj-fiche-onglets.liquid
   ---------------------------------------------------------------------------
   1 · ONGLETS. Le motif ARIA des onglets : un clic ou Entrée choisit ; les
       flèches gauche / droite, Début et Fin déplacent le focus ET choisissent
       (activation automatique — trois panneaux déjà dans la page, rien à
       charger). Un seul panneau visible, les autres en `hidden`.
   2 · NOTES. Une piste en défilement natif à points d'ancrage (le doigt la
       fait glisser comme les rails du site) ; les tirets suivent la note au
       défilement et y conduisent au clic. Les notes avancent seules toutes les
       7 s, seulement quand l'encart est à l'écran, jamais si l'utilisateur
       préfère un mouvement réduit — et plus du tout dès qu'on la survole, la
       touche, la fait défiler ou y met le focus : prendre la main rend la main
       (§5.2 tervicies).
   Rollback : voir l'en-tête du snippet.
   =========================================================================== */
(function () {
  'use strict';

  function monterOnglets(hote) {
    if (hote.dataset.vjPret === '1') return;
    hote.dataset.vjPret = '1';
    var onglets = Array.prototype.slice.call(hote.querySelectorAll('[role="tab"]'));
    function choisir(k, focus) {
      onglets.forEach(function (o, i) {
        var elle = i === k;
        o.classList.toggle('est-actif', elle);
        o.setAttribute('aria-selected', elle ? 'true' : 'false');
        o.tabIndex = elle ? 0 : -1;
        var p = document.getElementById(o.getAttribute('aria-controls'));
        if (p) p.hidden = !elle;
      });
      if (focus) onglets[k].focus();
    }
    onglets.forEach(function (o, i) {
      o.addEventListener('click', function () { choisir(i, false); });
      o.addEventListener('keydown', function (e) {
        var n = onglets.length, k = null;
        if (e.key === 'ArrowRight') k = (i + 1) % n;
        else if (e.key === 'ArrowLeft') k = (i - 1 + n) % n;
        else if (e.key === 'Home') k = 0;
        else if (e.key === 'End') k = n - 1;
        if (k === null) return;
        e.preventDefault();
        choisir(k, true);
      });
    });
  }

  function monterNotes(hote) {
    if (hote.dataset.vjPret === '1') return;
    hote.dataset.vjPret = '1';
    var piste = hote.querySelector('[data-vj-avant-achat-piste]');
    var notes = piste ? piste.children : [];
    var tirets = Array.prototype.slice.call(hote.querySelectorAll('.vj-avant-achat__tiret'));
    if (!piste || notes.length < 2) return;

    var courant = 0;
    var libre = true;        /* l'avance automatique est permise */
    var visible = false;
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function marquer(k) {
      courant = k;
      tirets.forEach(function (t, i) {
        t.classList.toggle('est-actif', i === k);
        t.setAttribute('aria-current', i === k ? 'true' : 'false');
      });
    }
    function aller(k, doux) {
      var cible = notes[k];
      if (!cible) return;
      piste.scrollTo({ left: cible.offsetLeft, behavior: doux && !reduit ? 'smooth' : 'auto' });
      marquer(k);
    }
    function rendreLaMain() { libre = false; }

    tirets.forEach(function (t, i) {
      t.addEventListener('click', function () { rendreLaMain(); aller(i, true); });
    });

    var attente = null;
    piste.addEventListener('scroll', function () {
      if (attente) window.cancelAnimationFrame(attente);
      attente = window.requestAnimationFrame(function () {
        var k = Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth));
        if (k !== courant && k >= 0 && k < notes.length) marquer(k);
      });
    }, { passive: true });

    ['pointerdown', 'touchstart', 'wheel', 'focusin', 'mouseenter'].forEach(function (ev) {
      hote.addEventListener(ev, rendreLaMain, { passive: true });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        visible = entrees[0] && entrees[0].isIntersecting;
      }, { threshold: 0.6 }).observe(hote);
    } else {
      visible = true;
    }

    if (!reduit) {
      window.setInterval(function () {
        if (!libre || !visible || document.hidden) return;
        aller((courant + 1) % notes.length, true);
      }, 7000);
    }
  }

  function demarrer() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vj-onglets]'), monterOnglets);
    Array.prototype.forEach.call(document.querySelectorAll('[data-vj-avant-achat]'), monterNotes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
  document.addEventListener('shopify:section:load', demarrer);
})();
